import { render, staticRenderFns } from "./DocStatistiques.vue?vue&type=template&id=850417a0&"
import script from "./DocStatistiques.vue?vue&type=script&lang=js&"
export * from "./DocStatistiques.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports